<template>
  <div class="comp" :class="{site: $store.state.user.privileges.guest, guestview: $store.state.user.privileges.guest}" v-loading="loading">
    <!-- <div class="grid options visible-xs" v-if="!$store.state.inapp">
      <span class="item">asd</span>
    </div> -->
    <!-- {{seat}} -->
    <div class="grid help hidden-xs" v-if="!$store.state.user.privileges.guest">
      <el-tooltip class="item" effect="dark" content="Aiuto" placement="top" :hide-after="2000">
        <a href="https://blog.ombrelleria.com/" target="new">
          <unicon name="question-circle" height="24" width="24" fill="#fff" />
        </a>
      </el-tooltip>
    </div>
    <div class="grid dashboard comp-inner" >

      <div class="grid navoptions visible-xs" v-if="!$store.state.user.privileges.guest">

<!--         <div class="">
            <el-tooltip class="item" effect="dark" content="Cerca disponibilitá" placement="top" :hide-after="2000">
              <el-popover
                placement="bottom"
                width="fit-content"
                trigger="click">
                <el-date-picker
                  v-model="mario.daterange"
                  type="daterange"
                  format="dd.MM.yyyy"
                  start-placeholder="Arrivo"
                  end-placeholder="Partenza"
                  :picker-options="pickerOptions">
                </el-date-picker>
                <button slot="reference" class="btn"><unicon name="calendar-alt" height="14" width="14" /></button>
              </el-popover>
            </el-tooltip>
          </div> -->

<!--           <el-popover
            placement="top"
            width="fit-content"
            trigger="click">
            <el-autocomplete
              class="inline-input"
              v-model="search"
              :fetch-suggestions="querySearch"
              placeholder="cerca ospite"
              :trigger-on-focus="false"
              @select="handleSelect"
              ref="querySearch"
              popper-class="querysearch"
              :popper-append-to-body="false"
              >
              <template slot-scope="{ item }">
                <span class="grid link">
                  <span class="date" v-if="item.now">oggi</span>
                  <span class="date" v-else>{{item.stay.start}}</span>
                  <span class="details">
                    {{item.ombrelloni | searchActualseat(today)}} {{ item.name }}
                  </span>
                </span>
              </template>
            </el-autocomplete>
            <button slot="reference" class="btn search"><unicon name="search" height="14" width="14" /></button>
          </el-popover> -->

          <button class="btn search" @click="searchDialog.open = true"><unicon name="search" height="14" width="14" /></button>

          

      </div>

      <el-dialog
            title="Cerca Ospite"
            :visible.sync="searchDialog.open"
            width="100%"
            :show-close="true"
            @opened="focus"
            @closed="search = '', searchGuestlist = []"
            fullscreen
            custom-class="searchDialog"
            destroy-on-close>
            <el-input ref="querySearch" v-model="search" @input="searchGuest" placeholder="nome ospite"></el-input>
            <div class="grid querysearch" style="margin-top: 32px;">
              <!-- {{searchGuestlist}} -->
              <!-- <div class="grid guest" v-for="(guest, index) in searchGuestlist" :key="index"> -->
                <span class="grid link" v-for="(guest, index) in searchGuestlist" :key="index" @click="handleSelect(guest)">
                  <span class="date" v-if="guest.now">oggi <span v-if="guest.room">: {{guest.room}}</span></span>
                  <!-- <span class="date" v-else>{{guest.stay.start}} - {{guest.stay.end}}</span> -->
                  <span class="grid details" v-for="(ombrellone, index) in guest.ombrelloni" :key="index">
                    <span class="date" v-if="!guest.now">{{guest.stay.start}} - {{guest.stay.end}} <span v-if="guest.room">: {{guest.room}}</span></span>
                    <!-- <span class="ombrid">{{guest.ombrelloni | searchActualseat(today)}}</span> {{ guest.name }} -->
                    <!-- <span class="ombrid">{{ombrellone.ombrid}} <small v-if="!guest.now">{{ombrellone.arrival}}/{{ombrellone.departure}}</small></span> {{ guest.name }} -->
                    <span class="ombrid">{{ombrellone.ombrid}}</span>
                    <span class="name">{{guest.name}}</span>
                  </span>
                </span>
                <div class="grid flatbox border" v-if="searchDialog.open && searchGuestlist.length < 1 && search.length > 0">
                  <small>non ci sono risultati per la ricerca</small>
                </div>
              <!-- </div> -->
            </div>
<!--             <el-autocomplete
              class="inline-input"
              v-model="search"
              :fetch-suggestions="querySearch"
              placeholder="cerca ospite"
              :trigger-on-focus="false"
              @select="handleSelect"
              ref="querySearch"
              popper-class="querysearch"
              >
              <template slot-scope="{ item }">
                <span class="grid link">
                  <span class="date" v-if="item.now">oggi</span>
                  <span class="date" v-else>{{item.stay.start}}</span>
                  <span class="details">
                    {{item.ombrelloni | searchActualseat(today)}} {{ item.name }}
                  </span>
                </span>
              </template>
            </el-autocomplete> -->
          </el-dialog>

      <div class="grid header">

        <div class="grid settings">

          <h3 v-if="$store.state.user.privileges.guest">{{$store.state.hotels.activehotel.name}}</h3>

          <!-- {{bookingrange}} -->

          <transition name="slide-fade" v-if="!$store.state.user.privileges.guest">
          <div v-if="add.open" class="grid seat mini active">
            <!-- {{add}} -->
            <p v-for="(seat, index) in add.seats" :key="index">{{seat.start}} - {{seat.end}}</p>
            <span class="icon" @click="add.open = false, resetDate()"><i class="fas fa-times"></i></span>
            <span class="grid name">{{add.guest.name}}</span>
            <span class="grid seats" @click="seatDialog.open = true, seatDialog.class = 'seatdetail active', seat = add.originseat, resetDate()">
              <!-- {{ombrelloni | filterFromSeat(add.guest)}} -->
              <!-- {{filteredSeats}} -->
              <span v-for="seat in filteredSeats" :key="seat.ombrelloneid">
                <span><strong>{{seat.ombrid}}:</strong> {{seat.arrival}} - {{seat.departure}}</span>
              <!--   <span v-for="guest in seat.guests" :key="guest.arrival">
                  {{seat.ombrid}}: {{guest.arrival}} - {{guest.departure}}
                </span> -->
                <!-- <p>{{seat}}</p> -->
              </span>
            </span>
            <!-- <p>{{add.guest}}</p> -->
            <!-- <p>{{add.seats}}</p> -->
          </div>
          </transition>

          <transition name="slide-fade">
            <button type="button" class="btn sm dark" @click="mario.active = false, mario.daterange = '', resetDate()" v-if="mario.active">
                <unicon name="times" height="16" width="16" fill="#fff"  />
            </button>
          </transition>

          <!-- <el-date-picker
            v-model="mario.daterange"
            type="daterange"
            format="dd.MM.yyyy"
            start-placeholder="Arrivo"
            end-placeholder="Partenza"
            :picker-options="pickerOptions">
          </el-date-picker> -->

          <!-- <el-slider v-model="zoom" :max="6" :min="1"></el-slider> -->

          <el-date-picker
            v-model="today"
            type="date"
            placeholder="Pick a day"
            format="dd.MM.yyyy"
            :picker-options="pickerOptions"
            @change="datePick">
          </el-date-picker>

          <div class="hidden-xs" v-if="!$store.state.user.privileges.guest">
            <el-autocomplete
              class="inline-input"
              v-model="search"
              :fetch-suggestions="querySearch"
              placeholder="cerca ospite"
              :trigger-on-focus="false"
              @select="handleSelect"
              popper-class="querysearch"
              >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <!-- <unicon slot="prefix" name="search" /> -->
              <template slot-scope="{ item }">
                <!-- <div class="value">{{ item }}</div> -->
                <!-- <span class="link" v-for="(guest, index) in item[0]" :key="index">{{ guest }}</span> -->
                <span class="grid link">
                  <span class="date" v-if="item.now">oggi <span v-if="item.room">: {{item.room}}</span></span>
                  <span class="date" v-else>{{item.stay.start}} - {{item.stay.end}} <span v-if="item.room">: {{item.room}}</span></span>
                  <!-- {{item.now}}/{{item.overall}} {{item.ombrelloni | searchActualseat(today)}} {{ item.name }} -->
                  <span class="details">
                    <strong style="margin-right: 4px;">{{item.ombrelloni | searchActualseat(today)}}</strong> {{ item.name }}
                    <!-- {{item.ombrelloni}} {{ item.name }} -->
                  </span>
                </span>
                <!-- <span class="link">{{item.now}}/{{item.overall}} {{ item.name }}</span> -->
              </template>
            </el-autocomplete>
          </div>

          <div class="hidden-xs" v-if="!$store.state.user.privileges.guest">
            <el-tooltip class="item" effect="dark" content="Cerca disponibilitá" placement="top" :hide-after="2000">
              <el-popover
                placement="bottom"
                width="fit-content"
                trigger="click">
                <el-date-picker
                  v-model="mario.daterange"
                  type="daterange"
                  format="dd.MM.yyyy"
                  start-placeholder="Arrivo"
                  end-placeholder="Partenza"
                  :picker-options="pickerOptions">
                </el-date-picker>
                <button slot="reference" class="btn"><unicon name="calendar-alt" height="14" width="14" /></button>
              </el-popover>
            </el-tooltip>
          </div>

          <div class="hidden-xs" v-if="!$store.state.user.privileges.guest">
          <el-tooltip class="item" effect="dark" content="Impostazioni ombrelloni" placement="top" :hide-after="2000">
            <!-- <el-popover
              placement="bottom"
              width="fit-content"
              trigger="click">
              <el-slider v-model="zoom" :max="6" :min="1"></el-slider>
            </el-popover> -->
            <button class="btn" @click="setseatview.open = true"><i class="el-icon-full-screen"></i></button>
          </el-tooltip>
        </div>

          <!-- <button @click="calendarview = !calendarview" class="btn" v-loading="loading"><unicon name="calendar-alt" height="14" width="14" /></button> -->

          <!-- <button @click="editseat.active = !editseat.active" class="btn" v-loading="loading"><unicon name="draggabledots" height="14" width="14" /></button> -->
          <!-- <button @click="show('editgrid')" class="btn" v-loading="loading"><unicon name="draggabledots" height="14" width="14" /></button> -->

          <button @click="openmenu()" class="btn visible-xs" v-if="!$store.state.user.privileges.guest"><i class="fas fa-bars"></i></button>
          <button v-if="$store.state.user.privileges.admin && !$store.state.user.privileges.guest" @click="openmenu()" class="btn hidden-xs"><i class="fas fa-bars"></i></button>
          <button v-else-if="!$store.state.user.privileges.guest" @click="logout()" class="btn red hidden-xs"><unicon name="sign-out-alt" height="16" width="16" fill="#fff" />logout</button>
        </div>

      </div>

<!--       <p v-for="seat in aiseats" :key="seat._id">
        <span v-if="!seat.occupied">{{seat}}</span>
      </p> -->

      <div class="grid beach" v-if="!calendarview && !mario.active">

        <!-- <p>{{mario}}</p> -->
        <!-- <p>{{aiseats}}</p> -->

        <div class="grid beach-inner" :style="style" :class="{sm: zoom === 1}" v-if="!editseat.active">
          <div class="grid seat sm" :class="{ active: checkDay(ombrellone.guests), free: !checkDay(ombrellone.guests), disabled: add.open && checkDay(ombrellone.guests), sm: !$store.state.hotels.activehotel.seatview.room && !$store.state.hotels.activehotel.seatview.guest && !$store.state.hotels.activehotel.seatview.stay && !$store.state.hotels.activehotel.seatview.items, notvisible: !ombrellone.visible, onlyroom: !$store.state.hotels.activehotel.seatview.guest && !$store.state.hotels.activehotel.seatview.stay && !$store.state.hotels.activehotel.seatview.items }" v-for="ombrellone in ombrelloni" :key="ombrellone._id" @click="(add.open && checkDay(ombrellone.guests)) ? nothing : ($store.state.user.privileges.guest && checkDay(ombrellone.guests)) ? nothing : seatDialog.open = true, seatDialog.class = checkDay(ombrellone.guests) ? 'grid seatdetail active' : 'grid seatdetail free', seat = ombrellone">
            <span class="grid id" :class="{withroom: $store.state.hotels.activehotel.seatview.room && $store.state.hotels.activehotel.settings.room}">{{ombrellone.ombrid}}</span>
            <span class="grid paid" v-if="checkDay(ombrellone.guests) && $store.state.hotels.activehotel.cashier && !$store.state.user.privileges.guest"><unicon name="exclamation-triangle" height="16" width="16" fill="#fff" v-if="checkDay(ombrellone.guests) && !checkBill(ombrellone.guests)" /></span>
            <span class="grid name" v-if="checkDay(ombrellone.guests) && $store.state.hotels.activehotel.seatview.guest">{{ombrellone.guests | guests(today) | name}}</span>
            <span class="grid stay" v-if="checkDay(ombrellone.guests) && $store.state.hotels.activehotel.seatview.stay">{{ombrellone.guests | guests(today) | stay}}</span>
            <span class="grid items" v-if="checkDay(ombrellone.guests) && $store.state.hotels.activehotel.seatview.items">
              <!-- <span v-for="(item, index) in $options.filters.toToday(guestsInday[ombrellone._id].items, today)" :key="index" v-html="item.icon"></span> -->
              <div v-for="(item, index) in $options.filters.toToday(guestsInday[ombrellone._id].items, today)" :key="index" class="grid item">
                <span class="grid badge">{{item.num}}</span>
                <span class="grid icon" v-html="item.icon"></span>
                <!-- <span class="grid name">{{item.name}}</span> -->
              </div>
            </span>
            <span class="grid room" v-if="checkDay(ombrellone.guests) && $store.state.hotels.activehotel.seatview.room && $store.state.hotels.activehotel.settings.room" :class="{onlyroom: !$store.state.hotels.activehotel.seatview.guest && !$store.state.hotels.activehotel.seatview.stay && !$store.state.hotels.activehotel.seatview.items}">{{ombrellone.guests | guests(today) | room}}</span>
          </div>
        </div>

        <div class="grid beach-inner" :style="style" :class="{sm: zoom === 1}" v-if="editseat.active">
          <div class="grid seat editseat" v-for="(ombrellone, index) in ombrelloni" :key="ombrellone._id" @click="seat = ombrellone, editseat.open = true">
            <span class="grid id">{{ombrellone.ombrid}}</span>
            <span>{{ombrellone.sortorder}} {{index}}</span>
          </div>
        </div>

      </div>

      <div class="grid beach" v-if="calendarview && !mario.active">
        <div class="grid beach-inner" :style="style">
          <div class="grid seat calendar"  v-for="ombrellone in ombrelloni" :key="ombrellone._id" >
            <span class="grid id">{{ombrellone.ombrid}}</span>
            <!-- <vc-calendar :attributes='ombrellonicalendar[ombrellone._id].attributes' :disabled-dates="ombrellonicalendar[ombrellone._id].disabled" /> -->
            <vc-date-picker
              mode='range'
              is-inline
              color="green"
              v-model="bookingrange[ombrellone._id]"
              locale="it-IT"
              :attributes='ombrellonicalendar[ombrellone._id].attributes'
              :disabled-dates="ombrellonicalendar[ombrellone._id].disabled"
              :masks="{data: ['L', 'DD.MM.YYYY'], input: ['L', 'DD.MM.YYYY']}"
            />
          </div>
        </div>
      </div>

      <div class="grid beach" v-if="!calendarview && mario.active">
        <div class="grid beach-inner" :style="style">
          <div class="grid seat" :class="{'active disabled': ombrellone.occupied, free: !ombrellone.occupied, notvisible: !ombrellone.ombrellone.visible}"  v-for="ombrellone in aiseats" :key="ombrellone._id" @click="ombrellone.occupied ? nothing : seatDialog.open = true, seatDialog.class = 'grid seatdetail free', seat = ombrellone.ombrellone">
            <span class="grid">{{ombrellone.ombrellone.ombrid}}</span>
          </div>
        </div>
      </div>

      <el-dialog
        title=""
        :visible.sync="seatDialog.open"
        width="fit-content"
        :show-close="false"
        :custom-class="seatDialog.class"
        @close="edit = false, $store.state.ombrelloni.openSeat.open = false, searchDialog.open =false, fromsearch ? resetDate() : nothing, fromsearch = false"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" v-if="!checkDay(seat.guests)">{{seat.ombrid}}</div>
            <div class="title" v-else style="font-size: 20px;">Dettaglio ombrellone</div>
            <!-- <unicon name="draggabledots" height="24" width="24" fill="#fff" /> -->
            <div class="grid oval" :class="{ active: checkDay(seat.guests)||fromsearch, free: !checkDay(seat.guests)||!fromsearch }"></div>
          </div>
        </template>
          <Seat
          :seat="seat"
          :checkDay="checkDay"
          :today="today"
          :add="add"
          :move="move"
          :bookingrange="bookingrange"
          :ombrelloni="ombrelloni"
          :fromsearch="fromsearch"
          :fromresult="fromresult"
          @closeseatDialog="seatDialog.open = !seatDialog.open, fromsearch ? resetDate() : nothing, fromsearch = false, searchDialog.open =false, !result ? '' : $router.replace('/')"
          @move="moveGuest"
          @addOmbrello="addOmbrello"
          @changeDate="changeDate"
          @sendPushmessage="onSendPushmessage"
          @sendPassmail="onSendPassmail"
          ></Seat>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="pushmessage.open"
        width="fit-content"
        :show-close="false"
        :custom-class="pushmessage.class"
        v-loading="$store.state.guests.loading"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <!-- <div class="title" v-if="!checkDay(seat.guests)">{{seat.ombrid}}</div> -->
            <div class="title" style="font-size: 20px;">Manda messaggio</div>
            <!-- {{pushmessage.matchedGuest}} -->
            <!-- <unicon name="draggabledots" height="24" width="24" fill="#fff" /> -->
            <!-- <div class="grid oval" :class="{ active: checkDay(seat.guests), free: !checkDay(seat.guests) }"></div> -->
          </div>
        </template>
          <Pushmessage :matchedGuest="pushmessage.matchedGuest" @close="pushmessage.open = false"></Pushmessage>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="sendpassmail.open"
        width="fit-content"
        :show-close="false"
        :custom-class="sendpassmail.class"
        v-loading="$store.state.guests.loading"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Manda Pass</div>
          </div>
        </template>
          <Sendpassmail :matchedGuest="sendpassmail.matchedGuest" @close="sendpassmail.open = false"></Sendpassmail>
      </el-dialog>

      <Errordialog :errordialog="errordialog" v-if="errordialog.open" @close="errordialog.open = false, $router.replace('/')"></Errordialog>

      <el-dialog
        title=""
        v-if="isMobileOnly"
        :visible.sync="updateExists"
        width="90%"
        :show-close="false"
        custom-class="error"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Update disponibile</div>
          </div>
        </template>
        <div>Prego conferma questo update per usufruire di tutte le fantastiche cose che offre Ombrelleria.</div>
        <div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
          <span class="btn reddark sm" @click="refreshApp"><unicon name="thumbs-up" fill="#fff" /> Ok</span>
        </div>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="setseatview.open"
        width="fit-content"
        :show-close="true"
        custom-class="setseatview"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Cambia visuale ombrellone</div>
          </div>
        </template>
        <SetSeatView :hotel="$store.state.hotels.activehotel" @close="setseatview.open = false"></SetSeatView>
      </el-dialog>

<!--       <el-dialog
        title=""
        :visible.sync="editseat.open"
        width="fit-content"
        :show-close="false"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Modifica ombrellone</div>
          </div>
        </template>
          <Editseat
          :seat="seat"
          @closeseatDialog="editseat.open = !editseat.open"
          ></Editseat>
      </el-dialog> -->

    </div>
  </div>
</template>

<script>
import helper from '../Mixins/helper'
import healthcheck from '../Mixins/healthcheck'
import Seat from '@/components/Seat.vue'
import Pushmessage from '@/components/micro/Pushmessage.vue'
import Sendpassmail from '@/components/micro/Sendpassmail.vue'
import Errordialog from '@/components/micro/Errordialog.vue'
import SetSeatView from '@/components/micro/SetSeatView.vue'
// import Editseat from '@/components/Editseat.vue'
import { isMobileOnly } from 'mobile-device-detect'
import _ from 'lodash'
import Moment from 'moment'
const moment = extendMoment(Moment)
import { extendMoment } from 'moment-range'
export default {
  name: 'Dashboard',
  mixins: [helper, healthcheck],
  props: {
    msg: String,
    guestList: Array,
    result: [String, Boolean]
  },
  data () {
    return {
      isMobileOnly: isMobileOnly,
      loading: false,
      calendarview: false,
      gridview: true,
      fromsearch: false,
      fromresult: false,
      setseatview: {
        open: false
      },
      searchDialog: {
        open: false
      },
      errordialog: {
        open: false,
        title: '',
        message: ''
      },
      sendpassmail: {
        open: false,
        class: 'default',
        matchedGuest: {}
      },
      pushmessage: {
        open: false,
        class: 'default',
        matchedGuest: {}
      },
      editseat: {
        active: false,
        open: false
      },
      bookingrange: {},
      mario: {
        active: false,
        daterange: ''
      },
      // jwt: localStorage.getItem('ombrelleria'),
      zoom: 1,
      today: moment().toDate(),
      search: '',
      move: {
        open: false,
        guest: {}
      },
      add: {
        open: false,
        guest: {},
        seats: [],
        originseat: {}
      },
      seatDialog: {
        open: false,
        class: ''
      },
      seat: {},
      pickerOptions: {
        firstDayOfWeek: 1
      },
      searchGuestlist: []
    }
  },
  components: {
    Seat,
    Pushmessage,
    Sendpassmail,
    Errordialog,
    SetSeatView
    // Editseat
  },
  sockets: {
    connect () {
      // console.log('socket to notification channel connected')
      this.$socket.emit('hello', {
        message: 'hi from vue',
        hotel: this.$store.state.hotels.activehotel,
        getUA: this.getUA
      })
    },
    stream (value) {
      // console.warn(value)
      if (value.title === 'Ombrellone Update' && value.hotelid === this.$store.state.hotels.activehotel._id && this.$store.state.user.privileges.guest) {
        this.$store.dispatch('beach/getBeach', this.$store.state.hotels.activehotel._id)
      }
    }
  },
  methods: {
    focus () {
      // console.log(this.$refs.querySearch)
      this.$refs.querySearch.$el.querySelector('input').focus()
    },
    onSendPushmessage (matchedGuest) {
      console.log(matchedGuest)
      this.pushmessage.matchedGuest = matchedGuest
      this.pushmessage.open = true
    },
    onSendPassmail (matchedGuest) {
      console.log(matchedGuest)
      this.sendpassmail.matchedGuest = matchedGuest
      this.sendpassmail.open = true
    },
    look: async function () {

    },
    checkBill (guests) {
      // console.log(guests)
      var self = this
      var guest = _.find(guests, function (o) {
        return moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
      })
      if (guest && guest.guestid) {
        var ombrelloni = _.find(this.$store.state.guests.guests, function (o) {
          return o._id === guest.guestid
        })
        // console.log(ombrelloni)
        if (ombrelloni === undefined) {
          // console.log('checkBill: undefined', guests, ombrid)
          return false
        }
        var unpaid = _.filter(ombrelloni.ombrelloni, function (o) {
          // console.log(o.paid)
          return o.paid === undefined || !o.paid
        })
        // console.log(unpaid)
        if (unpaid.length > 0) {
         return false
        } else {
         return true
        }
      }
    },
    changeDate (guest) {
      console.warn('changeDate: ', guest)
      // this.today = moment(guest.arrival, 'DD.MM.YYYY').toDate()
    },
    openseat () {
      // console.warn('open seat')
      // console.table(this.$store.state.hotels.activehotel.items)
      // this.$store.commit('hotels/SET_ACTIVEHOTEL', this.$store.state.hotels.activehotel)
    },
    nothing () {

    },
    resetDate () {
      this.today = moment().toDate()
      this.add = {
        open: false,
        guest: {},
        seats: [],
        originseat: {}
      }
      this.$emit('datePick', this.today)
    },
    moveGuest (value) {
      console.log(value)
      this.move = {
        open: true,
        guest: value
      }
    },
    addOmbrello (guest, seat) {
      console.log('addOmbrello dashboard ', guest, seat)
      this.add = {
        open: true,
        // guest: _.assignIn(guest, {items: _.last(guest.items).items}),
        guest: guest,
        seats: [],
        originseat: seat
      }
      this.today = moment(guest.departure, 'DD.MM.YYYY', true).add(1, 'd').toDate()
      // console.log(this.today)
      // this.add.seats.push(seat)
      this.seatDialog.open = false
    },
    datePick () {
      console.log(this.today)
      this.$emit('datePick', this.today)
    },
    querySearch (search, callback) {
      console.log(search)
      // var self = this
      // callback([search])
      // console.log(_.chain(this.guestList).filter({guests: [{name: search}]}).value())
      var now = _.filter(this.guestList, function (o) {
        // console.log(o)
        o.now = true
        var rooms = _.filter(o.ombrelloni, (ombrello) => {
          console.log(ombrello.room)
          return ombrello.room && ombrello.room.toLowerCase().includes(search.toLowerCase())
        })
        return o.name.toLowerCase().includes(search.toLowerCase()) || o.room.toLowerCase().includes(search.toLowerCase()) || rooms.length > 0
      })
      var overall = _.filter(this.$store.state.guests.guests, function (o) {
        // console.log(o)
        o.overall = true
        return o.name.toLowerCase().includes(search.toLowerCase()) && !o.now
      })
      // var seats = _.chain(this.$store.state.ombrelloni.ombrelloni).map('guests').flatten().filter((g) => { return g.room && g.room.toLowerCase().includes(search.toLowerCase()) }).value()
      // var seats = _.filter(this.$store.state.guests.guests, function (g) {
      //   return _.find(g.ombrelloni, (o) => {
      //     console.log(o.room)
      //     return o.room && o.room.toLowerCase().includes(search.toLowerCase())
      //   })
      // })
      var g = _.concat(now, overall)
      // console.log(seats)
      // console.log(g)
      // console.log(g)
      callback(g)
    },
    searchGuest (search) {
      console.log(search)
      // console.log(this.search)
      var now = _.filter(this.guestList, function (o) {
        o.now = true
        var rooms = _.filter(o.ombrelloni, (ombrello) => {
          console.log(ombrello.room)
          return ombrello.room && ombrello.room.toLowerCase().includes(search.toLowerCase())
        })
        return o.name.toLowerCase().includes(search.toLowerCase()) || o.room.toLowerCase().includes(search.toLowerCase()) || rooms.length > 0
      })
      var overall = _.filter(this.$store.state.guests.guests, function (o) {
        o.overall = true
        return o.name.toLowerCase().includes(search.toLowerCase()) && !o.now
      })
      var g = _.concat(now, overall)
      this.searchGuestlist = g
    },
    handleSelect (item) {
      console.log('handleSelect ', item)
      var self = this
      var seat = _.find(item.ombrelloni, function (o) {
        return moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]') || o
      })
      console.table(seat)
      // console.warn(_.find(this.ombrelloni, function (o) { return o._id === seat.ombrelloneid }))
      this.fromsearch = true
      this.today = moment(seat.arrival, 'DD.MM.YYYY').toDate()
      this.seat = _.find(this.ombrelloni, function (o) { return o._id === seat.ombrelloneid })
      this.seatDialog.open = true
      this.seatDialog.class = 'grid seatdetail active'
    },
    show (section) {
      console.log(section)
      this.$emit('open', section)
    },
    checkDay (guests) {
      // console.log('checkDay: ', guests)
      var self = this
      if (guests !== undefined && guests.length > 0) {
        return _.find(guests, function (o) {
          // console.log('checkDay: ', guests, moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]'))
          // console.log('jou', self.add, self.$store.state.hotels.activehotel.items)
          // if (!self.add.open) {self.guest.items = self.$store.state.hotels.activehotel.items}
          // if (self.add.open) {self.guest.items = self.add.guest.items}
          // console.log(moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]'))
          return moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
        })
      } else { return false }
    },
  },
  watch: {
    '$store.state.ombrelloni.openSeat.open' () {
      console.log('asdasd')
      // console.log(_.find(this.$store.state.ombrelloni.ombrelloni, {'_id': this.$store.state.ombrelloni.openSeat.seat.ombrelloni[0].ombrelloneid}))
      if (this.$store.state.ombrelloni.openSeat.open) {
        this.seatDialog.open = true
        this.seatDialog.class = 'grid seatdetail active'
        this.seat = _.find(this.$store.state.ombrelloni.ombrelloni, {'_id': this.$store.state.ombrelloni.openSeat.seat.ombrelloni[0].ombrelloneid})
      }
    },
    bookingrange (newv, oldv) {
      if (newv) {
        console.log('watch: ', newv, oldv)
      }
      this.add = {
        open: true,
        guest: {
          name: null,
          items: JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.items))
        },
        seats: newv
      }
      // if (newv) {
      //   this.add = {
      //     open: true,
      //     guest: {
      //       name: 'gernot'
      //     },
      //     seats: ['adsadasd']
      //   }
      // }
    },
    'mario.daterange' (newv, oldv) {
      console.log(newv, oldv)
      if (newv) {
        this.mario.active = true
        this.today = moment(newv).toDate()
      }
    }
    // calendarview () {
    //   // console.warn('loading')
    //   // this.gridview = !this.gridview
    //   // console.log(this.$nextTick)
    //   // console.warn(this.$refs.calendarview.update)
    //   // this.loading = false
    //   this.$nextTick().then(() => {
    //     // console.warn('no loading')
    //     // this.loading = false
    //   })
    // }
  },
  filters: {
    toToday (items, today) {
        console.log(items, today)
        // console.log('check', moment().isBetween(moment(items.period.start, 'DD.MM.YYYY'), moment(items.period.end, 'DD.MM.YYYY'), null, '[]'))
        var item = _.find(items, function (item) {
            // console.log('item ', item, moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]'), moment(today).isSame(moment(item.period.start, 'DD.MM.YYYY'), 'day'))
            if (item.period !== undefined) {
                // return moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]')||true
                return moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]')
            } else {
                return item
            }
        })
        // console.log(today, item)
        if (item && item.period !== undefined) {
            return item.items
        } else {
            // console.log('no period ', items)
            return _.find(items).items
        }
    },
    searchActualseat (guest, today) {
      // console.log(guest)
      // console.warn(today)
      var ombrid = _.find(guest, function (o) {
        return moment(today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]') || o
      })
      return ombrid.ombrid
    },
    guests (value, today) {
      if (value.length > 0) {
        // console.log(value, today)
        return _.find(value, function (o) {
          return moment(today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
        })
      } else {
        return
      }
    },
    name (value) {
      if (value) { return value.name } else {return '' }
    },
    room (value) {
      if (value) { return value.room } else {return '' }
    },
    stay (value) {
      if (value) { return value.arrival + ' - ' + value.departure } else {return '' }
    },
    items (value) {
      if (value) { return value.items } else {return '' }
    }
  },
  computed: {
    aiseats () {
      var range1 = moment.range(moment(this.mario.daterange[0]), moment(this.mario.daterange[1]));
      var dates = Array.from(range1.by('days')).map(m => m.format('DD.MM.YYYY'))
      // console.warn('mario ', range1)
      // range1.overlaps(range2) // true
      // var range3 = moment.range(moment('20.08.2020', 'DD.MM.YYYY'), moment('23.08.2020', 'DD.MM.YYYY'))
      // // var range4 = moment.range(moment(this.mario.daterange[0]), moment(this.mario.daterange[1]))
      // console.warn(range3.overlaps(range1))
      var ombrelloni = _.chain(this.ombrelloni).map(function (o) {
        // console.log(o)
        var free = []
        _.forEach(dates, function (date) {
          return !_.some(o.guests, function (g) {
            return moment(date, 'DD.MM.YYYY').isBetween(moment(g.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(g.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
          }) ? free.push(date) : ''
        })
        return {
          ombrellone: o,
          occupied: _.some(o.guests, function (g) {
            return range1.overlaps(moment.range(moment(g.arrival, 'DD.MM.YYYY'), moment(g.departure, 'DD.MM.YYYY')), { adjacent: true })
          }),
          adjacent: _.some(o.guests, function (g) {
            return range1.adjacent(moment.range(moment(g.arrival, 'DD.MM.YYYY'), moment(g.departure, 'DD.MM.YYYY')))
          }),
          free: free
        }
      }).value()
      // }).filter({occupied: false}).value()
      console.log('mario ', ombrelloni)
      return ombrelloni
    },
    filteredSeats () {
      var self = this
      // var result = []
      // console.log(self.add.guest.guestid)
      return _.chain(self.$store.state.ombrelloni.ombrelloni).filter(function (o) {
        return o.hotelid === self.$store.state.hotels.activehotel._id
      }).filter({guests: [{guestid: self.add.guest.guestid}]}).map(function (o) {
        var result = []
        _.flatMap(o.guests, function (g) {
          // console.log(g)
          if (g.guestid === self.add.guest.guestid) {
            result.push({ombrid: o.ombrid, arrival: g.arrival, departure: g.departure})
          }
        })
        // console.log(result)
        return result
      }).flatten().orderBy(function (t) {
        return moment(t.arrival, 'DD.MM.YYYY', true)
      }).value()
      // }).filter({guests: [{guestid: self.add.guest.guestid}]}).forEach('guests').map((value) => ({ ombrid: value.ombrid, guests: _.filter(value.guests, function (g) { return g.guestid === self.add.guest.guestid }) })).value()
    },
    ombrelloni () {
      var self = this
      return _.chain(self.$store.state.ombrelloni.ombrelloni).filter(function (o) {
        return o.hotelid === self.$store.state.hotels.activehotel._id
      }).orderBy('sortorder').value()
    },
    ombrellonicalendar () {
      // var self = this
      return _.chain(this.ombrelloni).keyBy('_id').mapValues(function (oc) {
        return {
          // ombrid: oc.ombrid,
          disabled: _.map(oc.guests, function (g) {
            return {
              start: g.arrival,
              end: g.departure
            }
          }),
          attributes: [{
            highlight: 'red',
            dates: _.map(oc.guests, function (g) {
            return {
                start: g.arrival,
                end: g.departure
              }
            })
          }]
        }
      }).value()
    },
    guestsInday () {
      var self = this
      return _.chain(self.$store.state.ombrelloni.ombrelloni).filter(function (o) {
        return o.hotelid === self.$store.state.hotels.activehotel._id
      }).keyBy('_id').mapValues(function (g) {
        return _.find(g.guests, function (d) {
          return moment(self.today).isBetween(moment(d.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(d.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
        })
        // return g.guests
      }).value()
    },
    style () {
      return 'grid-template-columns: repeat(' + this.$store.state.hotels.activehotel.cols + ', 1fr); grid-template-rows: repeat(' + this.$store.state.hotels.activehotel.rows + ', 1fr)'
    }
  },
  beforeMount () {
    if (!this.$store.state.user.privileges.guest) {
      this.$store.dispatch('ombrelloni/getOmbrelloni')
      this.$store.dispatch('guests/getGuests')
    }
    if (this.result) {
      var self = this
      console.log('we need to check a guest')
      // this.fromresult = true
      // this.seatDialog.open = true
      // this.seatDialog.class = 'grid seatdetail active'
      var guest = _.find(this.$store.state.guests.guests, {passid: self.result}) || false
      console.log('pass ', self.result, guest)
      var seat = _.find(this.$store.state.ombrelloni.ombrelloni, function (o) {
        return _.find(o.guests, {guestid: guest._id})
      })
      console.log(seat)
      if (guest && this.checkDay(seat.guests)) {
        this.seat = seat
        // this.fromresult = true
        this.seatDialog.open = true
        this.seatDialog.class = 'grid seatdetail active'
      } else {
        console.warn('passid expired or not valid today')
        this.errordialog = {
          open: true,
          title: 'Attenzione',
          message: 'Beachpass non valido'
        }
      }
    }
  },
  created () {
    // console.warn('hei dashboard')
    // console.log(this.today)
    // this.loading = false
    var convertdata = _.chain(this.$store.state.guests.guests).filter(function (o) {
      return _.find(o.ombrelloni, function (o2) {
        return _.find(o2.items, function (o3) {
          // console.log(o3.period)
          return o3.period === undefined
        })
      })
    }).value()
    // console.log('convert: ', convertdata)
    if (convertdata.length > 0) {
      // this.loading = true
      this.$notify({
        title: 'Conversione dati',
        message: 'doviamo convertire i dati',
        type: 'warning',
        duration: 0,
        // showClose: false,
        customClass: 'error'
      })
      // this.$store.dispatch('hotels/convertItems')
    }
    if (this.$store.state.hotels.activehotel.seasons && this.$store.state.hotels.activehotel.seasons.length === 0) {
      console.warn('no seasons in activehotel')
    }
    if (this.$store.state.hotels.activehotel.segments && this.$store.state.hotels.activehotel.segments.length === 0) {
      console.warn('no segments in activehotel')
      // this.$notify({
      //   title: 'Conversione dati',
      //   message: 'non hai definito un segmento',
      //   type: 'warning',
      //   duration: 0,
      //   // showClose: false,
      //   customClass: 'error'
      // })
    }
    if (this.$store.state.ombrelloni.ombrelloni.length === 0 && this.$store.state.hotels.hotels.length > 0) {
        console.warn('no ombrelloni')
        this.$emit('open', 'editgrid')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
